import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=0c31b4d6&"
import script from "./Participants.vue?vue&type=script&lang=js&"
export * from "./Participants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c31b4d6')) {
      api.createRecord('0c31b4d6', component.options)
    } else {
      api.reload('0c31b4d6', component.options)
    }
    module.hot.accept("./Participants.vue?vue&type=template&id=0c31b4d6&", function () {
      api.rerender('0c31b4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Participants.vue"
export default component.exports